import { Component, Input } from '@angular/core';

import { ApiService } from 'src/app/shared/api.service';
import { IEventActivity, IEventSettings } from 'src/app/shared/interfaces';

@Component({
    selector: 'aza-rws-activity-details',
    templateUrl: 'activity-details.component.html',
    styleUrls: ['activity-details.component.css'],
    standalone: false
})
export class ActivityDetailsComponent {
    @Input() activity: IEventActivity;
    @Input() eventSettings: IEventSettings;

    constructor(private readonly apiSvc: ApiService) {
    }

    async onLikeActivity(activity: IEventActivity): Promise<void> {
        await this.apiSvc.likeActivity(activity.id);
        activity.liked = true;
    }

    async onUnlikeActivity(activity: IEventActivity): Promise<void> {
        await this.apiSvc.unlikeActivity(activity.id);
        activity.liked = false;
    }
}
